import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function xmlValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // Não valida se estiver vazio (use Validators.required para isso)
    }

    try {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(control.value, 'text/xml');

      // Verifica se houve erro de parsing
      const parseError = xmlDoc.getElementsByTagName('parsererror');
      if (parseError.length > 0) {
        return { invalidXml: { message: 'XML inválido' } };
      }

      return null; // XML válido
    } catch (error) {
      return { invalidXml: { message: 'XML inválido' } };
    }
  };
}
